import{m as u}from"./chunk-HBP5N4FR.js";u();function t(n,i,r="..."){return isNaN(i)&&(i=10),r||(r="..."),n!=null&&(n.length<=i||n.length-r.length<=i)?n:String(n).substring(0,i-r.length)+r}export{t as a};
//# sourceMappingURL=chunk-A3JT4J5G.js.map
